import * as R from 'ramda'

export const LOADING = 'LOADING'

const updateState = (state, loading) => {
  return R.mergeDeepRight(state, { loading: loading })
}
export const loadingAction = loading => ({ type: LOADING, loading })

const initialState = {
  loading: false,
}

export default function loaderReducer(state = initialState, action) {
    switch (action.type) {
      case LOADING: {
        return updateState(initialState, action.loading)
      }
      default:
        return state
    }
  }